import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";

import api from "../../app/api";
import { errorSnack, successSnack } from "../snackbar/snackbarSlice";
import { uuidv4 } from "../../app/utils";
import baseURL from "../../app/utils.js";

export const submitSupportRequest = createAsyncThunk(
    "support/submitSupportRequest",
    async ({token, data}, thunkAPI) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = await api.post(
                `${baseURL}/v1/support/send`,
                data,
                config
            );

            thunkAPI.dispatch(
                successSnack("Support request submitted successfully.")
            );

            return response.data;
        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.error_description ||
                error.message ||
                "Failed to submit support request.";

            thunkAPI.dispatch(errorSnack(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const initialState = {
    submitStatus: "idle",
    error: null,
};

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        resetSupportState: (state) => {
            state.submitStatus = "idle";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitSupportRequest.pending, (state) => {
                state.submitStatus = "loading";
                state.error = null;
            })
            .addCase(submitSupportRequest.fulfilled, (state) => {
                state.submitStatus = "loaded";
            })
            .addCase(submitSupportRequest.rejected, (state, action) => {
                state.submitStatus = "error";
                state.error = action.payload || "Failed to submit support request.";
            });
    },
});

export const { resetSupportState } = supportSlice.actions;

export const selectSupport = (state) => state.support;

export default supportSlice.reducer;